export enum Routes {
  Timeline = '/timeline',
  AddConnection = '/connections',
  Summary = '/summary',
  MereAIAssistant = '/assistant',
  Settings = '/settings',
  OnPatientCallback = '/onpatient/callback',
  EpicCallback = '/epic/callback',
  CernerCallback = '/cerner/callback',
  VeradigmCallback = '/veradigm/callback',
  VACallback = '/va/callback',
}
